import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import Gantt from 'fusioncharts/fusioncharts.gantt';
import ReactFC from 'react-fusioncharts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
// Add the required chart type and theme
ReactFC.fcRoot(FusionCharts, Charts, Gantt, FusionTheme);
const GanttChart = ({ dataSource }) => {
    const chartRef = useRef(null);
    useEffect(() => {
        if (chartRef.current) {
            const chartConfigs = {
                type: 'gantt', // The chart type
                width: '100%', // Width of the chart
                height: '300', // Height of the chart
                dataFormat: 'json', // Data type
                dataSource: dataSource, // Data source
                containerBackgroundOpacity: '0',
            };
            new FusionCharts(chartConfigs).render(chartRef.current);
        }
    }, [dataSource]);
    return _jsx("div", { ref: chartRef, style: { width: '100%', height: '300px' } });
};
export default GanttChart;
